import React, {useEffect, useState} from "react";
import useSociety from "../../../hooks/useSociety";
import SocietyHomepageContact from "../../../components/societyHomepage/societyHomepageContact/SocietyHomepageContact";
import styles from "./SocietyHomepage.module.css";
import SocietyHomepageDescription
    from "../../../components/societyHomepage/societyHomepageDescription/SocietyHomepageDescription";
import {useSectionsRefs} from "../../../components/mainWrapper/MainWrapper";
import CartOverlay from "../../../components/cartOverlay/CartOverlay";
import {useCartOverlay} from "../../../hooks/useCart";
import SocietyHomepageGallery from "../../../components/societyHomepage/societyHomepageGallery/SocietyHomepageGallery";
import SocietyHomepageServices
    , {ServiceDTO} from "../../../components/societyHomepage/societyHomepageServices/SocietyHomepageServices";
import useDataFetch from "../../../hooks/useDataFetch";
import {
    ProductDTO
} from "../../../components/societyAdmin/societyAdminArticles/societyAdminArticlesList/SocietyAdminArticlesList";
import SocietyHomepageArticles
    from "../../../components/societyHomepage/societyHomepageArticles/SocietyHomepageArticles";
import {GalleryImageDTO} from "../gallery/SocietyGallery";
import SectionWrapper from "../../../components/sectionWrapper/SectionWrapper";

export interface SectionDTO {
    id: number,
    sectionType: string,
    orderSection: number,
}

const SocietyHomepage = () => {

    const {society} = useSociety();

    const {data: articles} = useDataFetch<ProductDTO[]>(`/societies/${society.id}/products`, true, true);
    const {data: galleryImages} = useDataFetch<GalleryImageDTO[]>(`/societies/${society.id}/gallery`, false, true);
    const {data: services} = useDataFetch<ServiceDTO[]>(`/societies/${society.id}/services`, false, true);

    const {
        societyDescriptionSection,
        societyServicesSection,
        articlesSection,
        societyGallerySection,
        contactSection,
        setNavItems,
        setDisplayRegisterSocietyButton,
        setDisplayCart,
        setDisplayMobileMenu,
    } = useSectionsRefs();

    const {isCartOpen, closeCart} = useCartOverlay();

    const [displayedSections, setDisplayedSections] = useState<SectionDTO[]>([]);

    useEffect(() => {
        const navItems = [
            {title: 'Accueil', scrollRef: societyDescriptionSection},
        ];

        if (society.secured || (society.services && society.services.length > 0)) {
            navItems.push({
                title: 'Services', scrollRef: societyServicesSection
            });
        }
        if (society.secured || (articles && (articles as ProductDTO[]).length > 0)) {
            navItems.push({
                title: 'Articles', scrollRef: articlesSection
            });
        }

        if (society.secured || (galleryImages && (galleryImages as GalleryImageDTO[]).length > 0)) {
            navItems.push({
                title: 'Gallerie', scrollRef: societyGallerySection
            });
        }

        navItems.push({
                title: 'Contact', scrollRef: contactSection
            }
        )

        setNavItems(navItems)
        setDisplayRegisterSocietyButton(false);
        setDisplayCart(true);
        setDisplayMobileMenu(true);
    }, [societyDescriptionSection, articlesSection, contactSection, setDisplayRegisterSocietyButton, setNavItems, setDisplayMobileMenu, articles, galleryImages]);

    useEffect(() => {
        if (society.sections) {
            const filteredAndSortedSections = society.sections
                .sort((a, b) => a.orderSection - b.orderSection)
                .filter(section => {
                    switch (section.sectionType) {
                        case 'SERVICES':
                            return society.secured! || (services && services.length > 0);
                        case 'ARTICLES':
                            return society.secured! || (articles && articles.length > 0);
                        case 'GALLERY':
                            return society.secured! || (galleryImages && galleryImages.length > 0);
                        default:
                            return false;
                    }
                });
            setDisplayedSections(filteredAndSortedSections);
        }
    }, [society.sections, society.secured, services, articles, galleryImages])

    return (
        <>
            <div className={styles.container}>
                {(society && society.enabled && society.visible) ? (
                    <>
                        <SocietyHomepageDescription/>

                        {displayedSections.length > 0 && (

                            displayedSections
                                .map((section: SectionDTO, index: number, array: SectionDTO[]) => {
                                    let sectionContent = null;
                                    let sectionRef = null;
                                    let display = false;
                                    let backgroundColor = 'primary.main';

                                    switch (section.sectionType) {
                                        case 'SERVICES':
                                            display = society.secured! || (services && services.length > 0);
                                            sectionContent = <SocietyHomepageServices services={services}/>;
                                            sectionRef = societyServicesSection;
                                            backgroundColor = 'secondary.main'
                                            break;
                                        case 'ARTICLES':
                                            display = society.secured! || (articles && articles.length > 0);
                                            sectionContent = <SocietyHomepageArticles articles={articles}/>;
                                            sectionRef = articlesSection;
                                            backgroundColor = 'tertiary.main'
                                            break;
                                        case 'GALLERY':
                                            display = society.secured! || (galleryImages && galleryImages.length > 0);
                                            sectionContent = <SocietyHomepageGallery galleryImages={galleryImages}/>;
                                            sectionRef = societyGallerySection;
                                            backgroundColor = 'senary.main'
                                            break;
                                        // Add cases for other section types and their corresponding components
                                        default:
                                            return null; // Don't render unknown section types
                                    }

                                    return display ? (
                                        <SectionWrapper
                                            key={section.id}
                                            isFirst={index===0}
                                            isLast={index === array.length-1}
                                            section={sectionContent}
                                            sectionRef={sectionRef}
                                            backgroundColor={backgroundColor}
                                            sectionId={section.id}
                                        />
                                    ) : null;
                                })
                        )}

                        <SocietyHomepageContact/>
                    </>
                ) : (
                    <div>
                        <p>Cette société n'est pas accessible actuellement.</p>
                        <p>Si vous en êtes le propriétéaire, veuillez vous connecter pour la gérer.</p>
                    </div>
                )}
            </div>
            <CartOverlay isCartOpen={isCartOpen} closeCart={closeCart}/>
        </>
    );
}

export default SocietyHomepage
